export const isDAM = (deviceCode: string): boolean => deviceCode.startsWith('DAM');
export const isDUT = (deviceCode: string): boolean => deviceCode.startsWith('DUT');

export const isDevice = (value: string): boolean => {
  const deviceRegex = /^(DMA|DMT|DAM|DAL|DUT|DAC|DRI)\d{9}$/;
  return deviceRegex.test(value);
};
